import api, { WisdomCashierSeal } from "api";
import { AppAction, AppButton, AppGridBar, AppGridLayout, AppGridTabs, AppRow, AppSearchItem, AppTable, AppTableSearch } from 'qcc';
import React from 'react';
import SealManageEditForm from './SealManageEditForm';

const sealStatus = { "xz": "新增", "yrz": "已认证" };
export default class extends React.Component {
  add = async () => {
    let projectId = 0;
    if (this.refTableSearch.current)
      projectId = (this.refTableSearch.current.state.data.projectId) || 0;
    if (projectId === 0) return;
    let formData = { type: 0, sealName: '', status: "xz", isEnabled: 0, projectId, projectName: "" } as WisdomCashierSeal;
    let title = '新增印章';
    let editForm = <SealManageEditForm mode={1} formData={formData} afterSave={this.afterSave} />
    AppAction.openDialog(editForm, { title, width: 600, height: 450 });

  }
  // 提交到法大大容器里面
  submit = async (Seal: any) => {
    Seal as WisdomCashierSeal;
    let res = await api.wisdomcashierseal.UploadSeal(Seal);
    this.refGrid.current && this.refGrid.current.state.refTable.fetch();
  }
  // 查看
  check = async (data?: any) => {
    let formData = await api.wisdomcashierseal.getOne({ id: data.id })
    let title = '查看印章';
  }
  // 编辑
  edit = async (data?: any) => {
    let formData = await api.wisdomcashierseal.getOne({ id: data.id })
    let title = '编辑印章';
    let editForm = <SealManageEditForm mode={2} formData={formData} afterSave={this.afterSave} />
    AppAction.openDialog(editForm, { title, width: 600, height: 450 });
  }
  // 启用
  enable = async (data: any) => {
    let id = data.id;
    if (await AppAction.confirm("您确定要启用该印章吗？")) {
      await api.wisdomcashierseal.enable({ id });
      AppAction.successMsg("操作成功！")
      this.refGrid.current && this.refGrid.current.state.refTable.fetch();
      return true;
    }
    return false;
  }

  // 禁用
  disable = async (data: any) => {
    let id = data.id;
    if (await AppAction.confirm("您确定要禁用该印章吗？")) {
      await api.wisdomcashierseal.disable({ id });
      AppAction.successMsg("操作成功！")
      this.refGrid.current && this.refGrid.current.state.refTable.fetch();
      return true;
    }
    return false;
  }

  // 删除
  delete = async (Seal: any) => {
    Seal as WisdomCashierSeal;
    console.log("Seal", Seal);
    if (Seal.is_enabled === 1) {
      AppAction.warnMsg("该印章已启用不可删除");
      return;
    }
    if (await AppAction.deleteConfirm('您确定要删除该印章吗？')) {
      let res = await api.wisdomcashierseal.delete(Seal);
      AppAction.successMsg('删除成功！');
      this.refGrid.current && this.refGrid.current.state.refTable.fetch();
    }
  }
  afterSave = () => {
    this.refGrid.current && this.refGrid.current.state.refTable.fetch();
    AppAction.closeDialog();
  }
  refGrid = React.createRef<AppGridLayout>();
  refTableSearch = React.createRef<AppTableSearch>();
  render() {
    return (
      <AppGridLayout ref={this.refGrid}>
        <AppGridLayout.SearchArea>
          <AppTableSearch ref={this.refTableSearch}>
            <AppTableSearch.Common>
              <AppSearchItem.ProjectTree keyName='projectId' projectTreeScene={6601} field='project_id' lable='项目：' />
            </AppTableSearch.Common>
          </AppTableSearch>
        </AppGridLayout.SearchArea>
        <AppGridLayout.MenuArea>
          <AppGridBar>
            <AppGridBar.Left>
              <AppGridTabs tabs={['项目印章列表']} />
            </AppGridBar.Left>
            <AppGridBar.Right>
              <AppRow style={{ float: 'right', marginRight: 20 }}>
                <AppButton label='新增' actionCode="66101501" type='primary' action={this.add} />
              </AppRow>
            </AppGridBar.Right>
          </AppGridBar>
        </AppGridLayout.MenuArea>
        <AppGridLayout.GridArea>
          <AppTable paging
            sqlId='sql.wisdomCashier.sealGird'
            onBeforeApi={(data: any) => { return data.projectId !== undefined }}
          >
            <AppTable.ColIndex />
            <AppTable.Col title='印章名称' field='seal_name' width={200} />
            <AppTable.Col title='印章编号' field='seal_code' width={200} />
            <AppTable.Col title='状态' field='status' align="center" width={100}
              render={
                (seal: any) => {
                  return (sealStatus[seal.status])
                }} />
            <AppTable.Col title='是否启用' field='is_enabled' align="center" width={100}
              render={
                (seal: any) => {
                  return (<span>{seal.is_enabled === 0 ? "否" : "是"}</span>)
                }
              } />
            <AppTable.Col title='印章' field='id' width={120}
              render={
                (data?: any, dataIndex?: number) => {
                  return (<div style={{ margin: '5px 0px' }}><img style={{ width: 100 }} src={data.seal_url} /></div>)
                }}
            />
            <AppTable.ColAction render={(data: any, dataIndex: number) => {
              let { is_enabled, status } = data
              return (<AppRow itemSplit={10} style={{ float: 'right' }}>
                {is_enabled === 0 && status === "yrz" ? <AppButton type='link' label='启用' actionCode="66101512" action={() => this.enable(data)} /> : null}
                {is_enabled === 1 && status === "yrz" ? <AppButton type='link' label='禁用' actionCode="66101512" action={() => this.disable(data)} /> : null}
                <AppButton type='link' label={data.is_delete === 0 && !data.seal_code ? "提交" : null} actionCode="66101511" action={() => this.submit(data)} />
                <AppButton type='link' label={data.is_delete === 0 && data.status === "xz" ? "编辑" : null} actionCode="66101502" action={() => this.edit(data)} />
                <AppButton type='link' label={data.is_enabled === 0 && data.status === "xz" ? "删除" : null} actionCode="66101503" action={() => this.delete(data)} />
              </AppRow>);
            }} />
          </AppTable>
        </AppGridLayout.GridArea>
      </AppGridLayout>
    )
  }
}


// WEBPACK FOOTER //
// ./src/page/pos/sealmanage/SealManageGrid.tsx